// src/AppRouter.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PaymentForm from '../components/PaymentForm';
import PaymentForm2 from '../components/PaymentForm2';
import PaymentResult from '../components/PaymentResult';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PaymentForm />} />
        <Route path="/cajuvalley" element={<PaymentForm />} />
        <Route path="/negociosdeimpacto" element={<PaymentForm2 />} />
        <Route path="/payment-result" element={<PaymentResult />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
